import React from 'react';
import './LoginPage.css';

function LoginPage() {
  const handleLogin = () => {
    const currentUrl = window.location.origin;
    const redirectUrl = encodeURIComponent(currentUrl);
    const state = '1';
    const ssoUrl = `https://sso.vmp.ir/index.php?work=url&redirect_uri=${redirectUrl}&client_id=VMP%20Dev%20Dashboard&state=${state}`;
    
    window.location.href = ssoUrl;
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1 className="vmp-logo">VMP</h1>
          <h2 className="dashboard-title">Developer Dashboard</h2>
        </div>
        
        <div className="login-content">
          <div className="login-message">
            <h3>Authentication Required</h3>
            <p>Please log in from the forum to access the VMP Developer Dashboard.</p>
          </div>
          
          <button 
            className="login-button"
            onClick={handleLogin}
          >
            Log in via VMP Forum
          </button>
        </div>
        
        <div className="login-footer">
          <p>VMP Platform - Developer Portal</p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;